import { httpGet, httpUpdate, NormalizedSearchResultDto, SearchResultDto } from "./claimsInvoicingApi";
import { InAppNotificationDto } from "@/types";

export const NOTIFICATIONS_PAGE_SIZE = 10;

export type NotificationsQueryFilter = {
    page: number; // 0-based for UI
    limit: number;
    isRead?: boolean;
};

const normalizeNotificationsResult = (
    raw: SearchResultDto<InAppNotificationDto>
): NormalizedSearchResultDto<InAppNotificationDto> => ({
    items: raw.items ?? [],
    returnedResults: raw.returnedResults ?? raw.items?.length ?? 0,
    pageIndex: Math.max(0, (raw.page ?? 1) - 1),
    totalResults: raw.totalResults ?? raw.items?.length ?? 0
});

export const getNotifications = async (
    params: NotificationsQueryFilter
): Promise<NormalizedSearchResultDto<InAppNotificationDto>> => {
    const { page, ...rest } = params;
    const queryParams = { page: page + 1, ...rest };
    const raw: SearchResultDto<InAppNotificationDto> = await httpGet("/invoice-notifications", {
        params: queryParams
    });

    return normalizeNotificationsResult(raw);
};

/** Fetches all unread notifications for the badge count and unread tab. */
export const getUnreadNotifications = async (): Promise<InAppNotificationDto[]> => {
    const raw: SearchResultDto<InAppNotificationDto> = await httpGet("/invoice-notifications", {
        params: { isRead: false }
    });

    return raw.items ?? [];
};

export const markNotificationAsRead = async (notificationId: string): Promise<void> =>
    httpUpdate(`/invoice-notifications/${notificationId}/read`, null);
